// Chat feature switch, set in .env:
//
//   REACT_APP_AQATO_ADMIN_PORTAL_CHAT_FULL_FEATURES = true    (or not set)  full chat
//   REACT_APP_AQATO_ADMIN_PORTAL_CHAT_FULL_FEATURES = false                  group chat only
//
// When false:
//   - New chat and New group are hidden
//   - My chats / All chats (Super Admin) are hidden
//   - Group members: view only (no rename, add people, remove, leave group)
//   - The list of chats is hidden; the page opens the user's group chat directly
//
// .env is read when "npm start" / "npm run build" starts, so restart or rebuild after changing it.

const rawValue = String(
  process.env.REACT_APP_AQATO_ADMIN_PORTAL_CHAT_FULL_FEATURES || "true"
)
  .trim()
  .toLowerCase();

export const CHAT_FULL_FEATURES = rawValue !== "false";
